export default {
  "content": "<g clip-path=\"url(#clip0_640_67260)\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10.833 10.821V9.348a7.59 7.59 0 00-3.322 4.777.26.26 0 01-.504.025 5.437 5.437 0 01-.257-1.653 5.553 5.553 0 014.083-5.334v-1.74a.427.427 0 01.675-.344l3.814 2.7a.42.42 0 010 .687l-3.814 2.699a.427.427 0 01-.675-.344zm6.16-.971c.17.534.257 1.092.257 1.653a5.552 5.552 0 01-4.083 5.334v1.74a.427.427 0 01-.675.344l-3.814-2.7a.42.42 0 010-.686l3.814-2.7a.426.426 0 01.675.344v1.473a7.588 7.588 0 003.322-4.777.261.261 0 01.504-.025z\" fill=\"#717684\"/></g><defs><clipPath id=\"clip0_640_67260\"><path fill=\"#fff\" transform=\"translate(5 5)\" d=\"M0 0h14v14H0z\"/></clipPath></defs>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};